module.exports = __webpack_public_path__ + "static/media/times.da5ef446.svg";